/* ============================================================
   THE CRUMBLE HUB – Event Logic v2
   ============================================================ */

(function () {
  'use strict';

  const isEventPaket = () =>
    window.__crumbleEventConfig && window.__crumbleEventConfig.isEventPaket === true;

  const isAddon = () =>
    window.__crumblePageMeta && window.__crumblePageMeta.isAddon === true;

  const isCommunity = () =>
    window.__crumbleEventConfig?.handle === 'the-community-crumble';

  // ── 1. QUANTITY PICKER ───────────────────────────────────
  function initQuantityPicker() {
    if (!isEventPaket()) return;
    const config = window.__crumbleEventConfig;
    const min = config.minPersons || 40;
    const max = config.maxPersons || 120;

    const qtyInput = document.querySelector(
      'input[name="quantity"], .quantity__input, input.qty'
    );
    if (!qtyInput) return;

    qtyInput.min = min;
    qtyInput.max = max;
    if (parseInt(qtyInput.value) < min) qtyInput.value = min;

    qtyInput.addEventListener('change', () => {
      let val = parseInt(qtyInput.value);
      if (val < min) qtyInput.value = min;
      if (val > max) qtyInput.value = max;
    });

    document.querySelectorAll('[name="plus"], .quantity__button[name="+"], .qty-btn-plus').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => { if (parseInt(qtyInput.value) > max) qtyInput.value = max; }, 10);
      });
    });
    document.querySelectorAll('[name="minus"], .quantity__button[name="-"], .qty-btn-minus').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => { if (parseInt(qtyInput.value) < min) qtyInput.value = min; }, 10);
      });
    });

    const hint = document.createElement('p');
    hint.className = 'crumble-qty-hint';
    hint.style.cssText = 'font-size:0.85em; color:#555; margin-top:4px;';
    hint.textContent = `Min. ${min} / Max. ${max} guests`;
    qtyInput.closest('div, .quantity')?.appendChild(hint);
  }

  // ── 2. CRUMBLE PICKER ───────────────────────────────────
  function initCrumblePicker() {
    return; // Picker bereits im Template (product-event-paket.liquid)
  }

  // ── 3. ADD-TO-CART VALIDATION ───────────────────────────
  function initCartValidation() {
    if (!isEventPaket()) return;
    const config = window.__crumbleEventConfig;
    const crumbleRequired = config.crumbleRequired !== false;
    const minChoose = config.minChoose || config.choose || 0;
    const maxChoose = config.maxChoose || config.choose || 0;
    const form = document.getElementById('product-form-event');
    if (!form) return;

    form.addEventListener('submit', (e) => {
      if (!crumbleRequired) return;
      const checkboxes = form.querySelectorAll('input[name="crumble_flavor"]');
      if (checkboxes.length === 0) return;
      const checked = [...checkboxes].filter(c => c.checked).length;
      if (checked < minChoose || checked > maxChoose) {
        e.preventDefault();
        e.stopPropagation();
        const label = minChoose === maxChoose ? `exactly ${minChoose}` : `${minChoose}–${maxChoose}`;
        alert(`Please select ${label} Crumble flavour${maxChoose > 1 ? 's' : ''}.`);
        return false;
      }
    }, true);
  }

  // ── 4. COMMUNITY CRUMBLE – Quantity=1 auf Produktseite ──
  function initCommunityQuantityLock() {
    if (!isCommunity()) return;

    const forms = [
      document.getElementById('product-form-event'),
      document.getElementById('product-form-voting')
    ].filter(Boolean);

    // PAX-Picker Wert lesen
    const paxPicker = document.getElementById('pax-input');

    forms.forEach(form => {
      const qtyHidden = form.querySelector('input[name="quantity"]');
      if (qtyHidden) qtyHidden.value = 1;
    });

    // Submit: quantity=1 erzwingen + PAX als Property
    forms.forEach(form => {
      form.addEventListener('submit', () => {
        const pax = paxPicker ? parseInt(paxPicker.value) || 40 : 40;

        const qtyHidden = form.querySelector('input[name="quantity"]');
        if (qtyHidden) qtyHidden.value = 1;

        let paxProp = form.querySelector('input[name="properties[Number of Guests]"]');
        if (!paxProp) {
          paxProp = document.createElement('input');
          paxProp.type = 'hidden';
          paxProp.name = 'properties[Number of Guests]';
          form.appendChild(paxProp);
        }
        paxProp.value = pax;
      }, true); // capture: vor Cowlendar
    });
  }

  // ── 5. CART LOGIC – Logistic Fee + Community Crumble Fix ─
  const eventPaketHandles = [
    'the-breakfast-crumble',
    'the-lunch-crumble',
    'the-dinner-crumble',
    'the-kids-crumble',
    'the-crumble-taste',
    'the-community-crumble'
  ];

  async function initCartLogic() {
    if (!window.location.pathname.includes('/cart')) return;

    const logisticHandle = window.__crumbleShopMeta?.logisticFeeHandle || 'logistic-fee';

    const cart = await fetch('/cart.js').then(r => r.json());
    const items = cart.items || [];

    const eventPaketItem = items.find(i => eventPaketHandles.includes(i.handle));
    const hasEventPaket = !!eventPaketItem;
    const logisticItem = items.find(i => i.handle === logisticHandle);

    // Logistic Fee
    if (hasEventPaket && !logisticItem) {
      const variantId = await getVariantIdByHandle(logisticHandle);
      if (variantId) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        window.location.reload();
        return;
      }
    } else if (!hasEventPaket && logisticItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: logisticItem.key, quantity: 0 })
      });
      window.location.reload();
      return;
    }

    // Community Crumble: Quantity im Warenkorb auf 1 korrigieren
    // PAX-Zahl (originale Quantity) als Property sichern
    const communityItem = items.find(i => i.handle === 'the-community-crumble');
    if (communityItem && communityItem.quantity !== 1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: communityItem.key,
          quantity: 1,
          properties: {
            ...communityItem.properties,
            'Number of Guests': communityItem.quantity
          }
        })
      });
      window.location.reload();
      return;
    }
  }

  async function getVariantIdByHandle(handle) {
    try {
      const data = await fetch(`/products/${handle}.js`).then(r => r.json());
      return data.variants?.[0]?.id;
    } catch (e) {
      console.warn('Crumble: Produkt nicht gefunden:', handle);
      return null;
    }
  }

  // ── 6. ADDON-ONLY GUARD ──────────────────────────────────
  function initAddonGuard() {
    if (!isAddon()) return;
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const hasEventPaket = (cart.items || []).some(i => eventPaketHandles.includes(i.handle));
      if (!hasEventPaket) {
        const form = document.querySelector('form[action*="/cart/add"]');
        const addBtn = form?.querySelector('[type="submit"]');
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Book an Event Package first';
          addBtn.style.opacity = '0.5';
        }
        const notice = document.createElement('p');
        notice.style.cssText = 'color:#CC0000; font-size:0.9em; margin-top:8px;';
        notice.textContent = 'This add-on can only be booked together with an Event Package.';
        addBtn?.parentElement?.appendChild(notice);
      }
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    if (isEventPaket()) {
      const style = document.createElement('style');
      style.textContent = `
        .product-form__submit, button[type="submit"].button {
          background-color: #8A1C1C !important;
          color: #f7f7f7 !important;
          border-color: #8A1C1C !important;
        }
        .quantity__input, input[name="quantity"] {
          color: #8A1C1C !important;
          font-weight: bold !important;
          text-align: center !important;
        }
      `;
      document.head.appendChild(style);
    }
    initQuantityPicker();
    initCrumblePicker();
    initCartValidation();
    initCommunityQuantityLock();  // ← Produktseite: quantity=1 + PAX als Property
    initAddonGuard();
    initCartLogic();              // ← Warenkorb: Fallback-Korrektur falls Cowlendar gewinnt
  });

})();
